export const isDAM = (deviceCode: string): boolean => deviceCode.startsWith('DAM');
export const isDUT = (deviceCode: string): boolean => deviceCode.startsWith('DUT');
export const isDRI = (deviceCode: string): boolean => deviceCode.startsWith('DRI');

export const isDevice = (value: string): boolean => {
  const deviceRegex = /^(DMA|DMT|DAM|DAL|DUT|DAC|DRI)\d{9}$/;
  return deviceRegex.test(value);
};

/**
 * Um DRI de fancoil/VAV pode estar configurado com sonda externa: nesse caso a leitura do ambiente é `ExtTemp`,
 * e não `TempAmb`. Quem escolhe é o `SensorSelect`, em tempo de execução — por isso o nome do campo, sozinho,
 * não descreve a fonte.
 */
export const readDriAmbientTemperature = (
  telemetry: { SensorSelect?: number; ExtTemp?: number; TempAmb?: number },
): number | undefined => {
  if (telemetry.SensorSelect === 1 && telemetry.ExtTemp != null) {
    return telemetry.ExtTemp;
  }

  return telemetry.TempAmb;
};
